import { render, staticRenderFns } from "./ComissaoDadosMembros.vue?vue&type=template&id=4e0f4c78&scoped=true"
import script from "./ComissaoDadosMembros.vue?vue&type=script&lang=js"
export * from "./ComissaoDadosMembros.vue?vue&type=script&lang=js"
import style0 from "./ComissaoDadosMembros.vue?vue&type=style&index=0&id=4e0f4c78&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f4c78",
  null
  
)

export default component.exports